import script from "./NovelList.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelList.vue?vue&type=script&setup=true&lang=js"

import "./NovelList.vue?vue&type=style&index=0&id=e40373de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e40373de"]])

export default __exports__